/* "Load more products" for collection grids (2026-09-19).
   Numbered pagination links stay in the page (crawlable, works without JS); this only adds a button that
   fetches the next page and appends its products. Revert: delete this file and the button block in
   sections/main-collection-product-grid.liquid. */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-loadmore]');
    if (!btn || btn.disabled) return;
    var url = btn.getAttribute('data-next-url');
    var grid = document.getElementById('product-grid');
    if (!url || !grid) return;
    e.preventDefault();
    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = 'Loading...';
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = doc.querySelectorAll('#product-grid > li');
        items.forEach(function (li) { grid.appendChild(document.importNode(li, true)); });
        var nextBtn = doc.querySelector('[data-loadmore]');
        var wrap = btn.closest('.collection-loadmore');
        if (nextBtn) {
          btn.setAttribute('data-next-url', nextBtn.getAttribute('data-next-url'));
          var cap = doc.querySelector('.collection-loadmore .caption');
          if (cap && wrap && wrap.querySelector('.caption')) wrap.querySelector('.caption').textContent = cap.textContent;
          btn.disabled = false;
          btn.textContent = label;
        } else if (wrap) {
          wrap.hidden = true;
        }
        if (window.jdgm && typeof window.jdgm.customizeBadges === 'function') { try { window.jdgm.customizeBadges(); } catch (err) {} }
      })
      .catch(function () { btn.disabled = false; btn.textContent = label; window.location.href = url; });
  });
})();
